import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { PIMProvider } from './context/PIMContext.jsx'
import { ToastProvider } from './context/ToastContext.jsx'


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ToastProvider>
      <PIMProvider>
        <App />
      </PIMProvider>
    </ToastProvider>
  </React.StrictMode>,
);
